import { Injectable } from '@angular/core';
// @ts-ignore
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})

export class RestApiService {

  /*========================================
                  Variables
  =========================================*/

  private protocol: string = environment.api.protocol;
  private apiURL: string = environment.api.url;
  private headers: HttpHeaders = new HttpHeaders();

  constructor(
    private http: HttpClient
  ) { }

  /*========================================
              Configure service
  =========================================*/

  public setProtocol(protocol): void {
    this.protocol = protocol;
  }

  public getProtocol(): string {
    return this.protocol;
  };

  public setApiURL(apiURL): void {
    this.apiURL = apiURL;
  };

  public getApiURL(): string {
    return this.apiURL
  };

  public setAuthorization(authorization: string): void {
    this.setHeader('Authorization', authorization);
  };

  public setHeader(key, value): void {
    console.log(key, value);
    this.headers = this.headers.set(key, value);
  };

  public getHeaders(): HttpHeaders {
    return this.headers;
  };

  public unsetHeader(key): void {
    this.headers.delete(key);
  };

  /*========================================
                     Misc
  =========================================*/

  private paramsToStringParameter(params): String {
    return Object.keys(params).map(key => key + '=' + params[key]).join('&');
  };

  private paramsToHttpParams(params): HttpParams {
    let httpParams = new HttpParams();

    Object.keys(params).forEach((key) => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  };

  /*========================================
        Methods to consume RESTful API
  =========================================*/

  vget(endpoint, params, toString?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers,
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params),
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers,
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params),
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      }
    }
  };

  vpost(endpoint, params, toString?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.post(endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.post(endpoint, params, {
            headers: this.headers,
            params: this.paramsToHttpParams(params),
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.post(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.post(this.protocol + '://' + this.apiURL + endpoint, params, {
            headers: this.headers,
            params: this.paramsToHttpParams(params),
            observe: 'response'
          }).subscribe((res: any) => {
            resolve(res);
          }, (err: any) => {
            resolve(err);
          });
        });
      }
    }
  };

  vpostBody(endpoint, Body, token): Promise<any> {
    let headers = new HttpHeaders();
    headers = headers.set("Authorization", "Bearer " + token);

    if (environment.useProxy === true) {
      return new Promise((resolve, reject) => {
        this.http.post(endpoint, Body, {
          headers: headers,
          observe: 'response',
        }).subscribe((res: any) => {
          resolve(res);
        }, (err: any) => {
          resolve(err);
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        this.http.post(this.protocol + '://' + this.apiURL + endpoint, Body, {
          headers: headers,
          observe: 'response'
        }).subscribe((res: any) => {
          resolve(res);
        }, (err: any) => {
          resolve(err);
        });
      });
    }
  };

  get(endpoint, params, toString?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params)
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params)
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }

    }
  };

  getLocalTest(endpoint, params, toString?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(`http://localhost:3003/` + endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params)
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {
            headers: this.headers
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.get(this.protocol + '://' + this.apiURL + endpoint, {
            headers: this.headers,
            params: this.paramsToHttpParams(params)
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }

    }
  };

  post(endpoint, params, toString?, responseType?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.post(endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.post(endpoint, params, {
            headers: this.headers,
            responseType: responseType,
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.post(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.post(this.protocol + '://' + this.apiURL + endpoint, params, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }

    }
  };

  put(endpoint, params, toString?, responseType?): Promise<any> {
    if (environment.useProxy === true) {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.put(endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.put(endpoint, params, {
            headers: this.headers,
            responseType: responseType,
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }
    } else {
      if (toString === true) {
        return new Promise((resolve, reject) => {
          this.http.put(this.protocol + '://' + this.apiURL + endpoint + '?' + this.paramsToStringParameter(params), {}, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      } else {
        return new Promise((resolve, reject) => {
          this.http.put(this.protocol + '://' + this.apiURL + endpoint, params, {
            headers: this.headers,
            responseType: responseType
          }).subscribe((res: any) => {
            resolve(res);
          });
        });
      }

    }
  };

  delete(endpoint, responseType?): Promise<any> {
    if (environment.useProxy === true) {
      return new Promise((resolve, reject) => {
        this.http.delete(endpoint, {
          headers: this.headers,
          responseType: responseType,
        }).subscribe((res: any) => {
          resolve(res);
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        this.http.delete(this.protocol + '://' + this.apiURL + endpoint, {
          headers: this.headers,
          responseType: responseType
        }).subscribe((res: any) => {
          resolve(res);
        });
      });
    }
  };
}